// DO NOT EDIT -- generated from fs/services/capnhook/cron.proto

export namespace Cron {

  export const StartHealthChecksEndpoint = "/grpc/capnhook.Cron/StartHealthChecks";
  export function StartHealthChecks(sender: (req: {}, endpoint: string) => Promise<{}>, req: {}): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, StartHealthChecksEndpoint),
      endpoint: StartHealthChecksEndpoint
    };
  }
}

export interface WebhookCronTask {
  orgId: string;
}
